import script from "./TabsContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./TabsContainer.vue?vue&type=script&setup=true&lang=js"

import "./TabsContainer.vue?vue&type=style&index=0&id=bfd45308&scoped=true&lang=scss"

import exportComponent from "E:\\Projects\\big-screen\\ori\\nnu-data-viewer-1204\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bfd45308"]])

export default __exports__